module.exports = __webpack_public_path__ + "img/question-icon.1b15fe07.svg";